<tt-page>
    <tt-order-pick-view [params]="params"></tt-order-pick-view>
</tt-page>
